'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n'], ['\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation: ', ';\n  background: ', ';\n  background: ', ';\n  border-radius: 50%;\n  font-size: ', ';\n  height: 11em;\n  margin: 50px auto;\n  position: relative;\n  text-indent: -9999em;\n  transform: translateZ(0);\n  width: 11em;\n\n  &:before {\n    background: ', ';\n    border-radius: 100% 0 0 0;\n    content: \'\';\n    height: 50%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 50%;\n  }\n\n  &:after {\n    background: ', ';\n    border-radius: 50%;\n    bottom: 0;\n    content: \'\';\n    height: 75%;\n    left: 0;\n    margin: auto;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 75%;\n  }\n'], ['\n  animation: ', ';\n  background: ', ';\n  background: ', ';\n  border-radius: 50%;\n  font-size: ', ';\n  height: 11em;\n  margin: 50px auto;\n  position: relative;\n  text-indent: -9999em;\n  transform: translateZ(0);\n  width: 11em;\n\n  &:before {\n    background: ', ';\n    border-radius: 100% 0 0 0;\n    content: \'\';\n    height: 50%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 50%;\n  }\n\n  &:after {\n    background: ', ';\n    border-radius: 50%;\n    bottom: 0;\n    content: \'\';\n    height: 75%;\n    left: 0;\n    margin: auto;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 75%;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var loading = (0, _styledComponents.keyframes)(_templateObject);

var Spin = _styledComponents2.default.div(_templateObject2, function (props) {
  return loading + ' ' + props.duration + 's infinite linear;';
}, function (props) {
  return props.color;
}, function (props) {
  return 'linear-gradient(to right, ' + props.color + ' 10%, rgba(255, 255, 255, 0) 42%);';
}, function (props) {
  return props.size + 'px';
}, function (props) {
  return props.color;
}, function (props) {
  return props.background;
});

exports.default = Spin;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-loaders2/dist/spin/Spin.js
// module id = 563
// module chunks = 0